function patchFeaturedProducts() {
  const fp = window.themeCore?.FeaturedProducts;
  
  if (!fp) {
    setTimeout(patchFeaturedProducts, 50);
    return;
  }

  document.querySelectorAll('.js-featured-products').forEach((section) => {
    const slider = section.querySelector('.js-featured-products-slider');
    if (!slider) return;

    let slidesPerViewDesktop = +slider.getAttribute("data-slides-in-row") || 4;

    if (!slider?.swiper) return;

    slider.swiper.params.slidesPerView = 1;
    slider.swiper.originalParams.slidesPerView = 1;

    slider.swiper.params.breakpoints[768] = { slidesPerView: 2 };
    slider.swiper.originalParams.breakpoints[768] = { slidesPerView: 2 };

    slider.swiper.params.breakpoints[1024] = { slidesPerView: 3 };
    slider.swiper.originalParams.breakpoints[1024] = { slidesPerView: 3 };

    slider.swiper.params.breakpoints[1200] = { slidesPerView: slidesPerViewDesktop };
    slider.swiper.originalParams.breakpoints[1200] = { slidesPerView: slidesPerViewDesktop };

    slider.swiper.currentBreakpoint = false;
    slider.swiper.setBreakpoint();
    slider.swiper.update();

  });
}

patchFeaturedProducts();